import { RefObject } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { IconButton } from '@cbhq/cds-web/buttons';

type AppSwitcherButtonProps = {
  buttonRef?: RefObject<HTMLButtonElement>;
  onPress?: () => void;
};

const messages = defineMessages({
  a11yLabel: {
    id: 'AppSwitcherButton.a11yLabel',
    defaultMessage: 'App switcher menu',
  },
});

export function AppSwitcherButton({ buttonRef, onPress }: AppSwitcherButtonProps) {
  const { formatMessage } = useIntl();
  return (
    <IconButton
      testID="AppSwitcherButton"
      accessibilityLabel={formatMessage(messages.a11yLabel)}
      name="appSwitcher"
      variant="secondary"
      ref={buttonRef}
      onClick={onPress}
    />
  );
}
